import { TinyEmitter } from 'tiny-emitter';

type EventCallback = (...args: any[]) => void; // 定义一个函数类型

class EventBus {
  emitter: TinyEmitter;
  constructor() {
    this.emitter = new TinyEmitter();
  }

  $emit(event: string, ...args: any[]) {
    this.emitter.emit(event, ...args);
    return this;
  }

  $on(event: string, callback: EventCallback) {
    // 添加类型定义
    this.emitter.on(event, callback);
    return this;
  }

  $off(event: string, callback: EventCallback) {
    // 添加类型定义
    this.emitter.off(event, callback);
    return this;
  }
}

export default new EventBus();
